export default __webpack_public_path__ + "static/media/javascript-es6.4408daaa.jpg";